<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit h-inlineLabel">{{$t("Pm.indicatorList")}}</div>
        <div class="h-inlineInput">
            <input  class="e-control e-textbox e-lib e-input" type="text" maxlength="255" v-model='searchString' :placeholder='$t("Pm.searchByName")'>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox h-tableHeight210 h-tableNoPage">
      <div class="col-sm-12 h-col-inputBox  h-tableNoPage">
        <ejs-grid ref='grid' :dataSource="searchData"  :allowPaging='false' :allowSorting='false' :recordDoubleClick='recordDoubleClick' :height='180'>
          <e-columns>
            <e-column field='counterCodeCnEn' :headerText='$t("Pm.name")' width='60%' textAlign='left' isPrimaryKey='true' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='counterCode' :headerText='$t("Pm.indicatorID")'  width='15%' textAlign='left' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='counterUnitCnEn' :headerText='$t("Pm.unit")' width='15%' textAlign='left' clipMode='EllipsisWithTooltip'></e-column>
          </e-columns>
        </ejs-grid>
         <!-- <ejs-pager ref='pagerOfAddCustomKPI' @click='getDataForAddCustomKpi()' :currentPage='pageSettingsForAddCustom.currentPage' :pageCount='pageSettingsForAddCustom.pageCount' :pageSize='pageSettingsForAddCustom.pageSize' :totalRecordsCount='pageSettingsForAddCustom.totalRecordsCount'></ejs-pager>
          -->
      </div> 
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox h-bg-blueTextarea">
        <div class="h-inputLit"><span class="h-red-code">* </span>{{$t("Pm.indicatorFormulaText")}}</div>
        <div class="e-float-input e-control-wrapper">
          <ejs-textbox ref="formula" id="default" maxlength="255" :multiline="true"
          floatLabelType="Never" :placeholder='$t("Pm.doubleClickChoose")' :value='formula' :readonly='isCodeName' :change='changeFormula'></ejs-textbox>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-borderBox ">
          <div class="h-buttonBg">
            <div class="width-200 h-inlineBg">
              <ejs-button id="roundbtn17" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native="formulaDisplay" :disabled='isCodeName'>7</ejs-button>
              <ejs-button id="roundbtn18" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native="formulaDisplay" :disabled='isCodeName'>8</ejs-button>
              <ejs-button id="roundbtn19" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native="formulaDisplay" :disabled='isCodeName'>9</ejs-button>
              <ejs-button id="roundbtn14" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native="formulaDisplay" :disabled='isCodeName'>4</ejs-button>
              <ejs-button id="roundbtn15" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native="formulaDisplay" :disabled='isCodeName'>5</ejs-button>
              <ejs-button id="roundbtn16" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native="formulaDisplay" :disabled='isCodeName'>6</ejs-button>
              <ejs-button id="roundbtn11" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native="formulaDisplay" :disabled='isCodeName'>1</ejs-button>
              <ejs-button id="roundbtn12" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native="formulaDisplay" :disabled='isCodeName'>2</ejs-button>
              <ejs-button id="roundbtn13" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native="formulaDisplay" :disabled='isCodeName'>3</ejs-button>
            </div>
            <div class="width-135 h-inlineBg">
              <ejs-button id="roundbtn110" class="e-control e-btn e-lib h-normal h-orange e-round" @click.native="formulaDisplay" :disabled='isCodeName'>+</ejs-button>
              <ejs-button id="roundbtn111" class="e-control e-btn e-lib h-normal h-orange e-round" @click.native="formulaDisplay" :disabled='isCodeName'>/</ejs-button>
              <ejs-button id="roundbtn112" class="e-control e-btn e-lib h-normal h-orange e-round" @click.native="formulaDisplay" :disabled='isCodeName'>-</ejs-button>
              <ejs-button id="roundbtn113" class="e-control e-btn e-lib h-normal h-orange e-round" @click.native="formulaDisplay" :disabled='isCodeName'>(</ejs-button>
              <ejs-button id="roundbtn114" class="e-control e-btn e-lib h-normal h-orange e-round" @click.native="formulaDisplay" :disabled='isCodeName'>*</ejs-button>
              <ejs-button id="roundbtn115" class="e-control e-btn e-lib h-normal h-orange e-round" @click.native="formulaDisplay" :disabled='isCodeName'>)</ejs-button>
            </div>
            <div class="width-65 h-inlineBg">
              <ejs-button id="roundbtn116" class="e-control e-btn e-lib h-normal h-green e-round" @click.native="switchFormula">{{$t("Pm.switch")}}</ejs-button>
              <ejs-button id="roundbtn117" class="e-control e-btn e-lib h-normal h-pink e-round" @click.native="revoke" :disabled='isCodeName'>{{$t("Pm.revoke")}}</ejs-button>
              <ejs-button id="roundbtn118" class="e-control e-btn e-lib h-normal h-red e-round" @click.native="clear" :disabled='isCodeName'>{{$t("Pm.clear")}}</ejs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-clear-rowMg"></div>
  </div>
</template>

<script>
import { Reorder, Resize, ExcelExport, ContextMenu, Toolbar, Page, click } from '@syncfusion/ej2-vue-grids';

export default {
  name: 'addKPI2',
  components: {
  },
  props: {
    nodeParam: {
      netypeid: '',
      measureobjecttypecode: '',
      countertypeid: '',
      neversionid: '',
      text: {},
      isLeaf: false
    },
    counterFormulaUi: '',
    isAddMode: '',
    isNextStep: false,
  },
  data() {
    return {
      searchString: '',
      history: [],
      isCodeName: false,
      historySwitch: [],
      pageSettingsForAddCustom: {
        currentPage: 1,
        pageSize: 10000,
        totalRecordsCount: 0,
        pageCount: 10
      },
      dataForList: [],
      action: false,
      formula: this.counterFormulaUi,
      switchFormulaBefore: '',
    };
  },
  methods: {
    formulaDisplay(event) {
      if (this.isCodeName) {
        return;
      }
      this.formula = this.formula + event.target.innerText;
    },
    clear() {
      if (this.isCodeName) {
        return;
      }
      this.action = true;
      this.formula = '';
      this.history = [];
    },
    revoke() {
      if (this.isCodeName) {
        return;
      }

      this.action = true;
      const length = this.history.length;
      if (length > 1) {
        this.history.pop();
        this.formula = this.history[length - 2];
        return;
      } else if (length === 1) {
        this.history.pop();
      }
      this.formula = '';
    },
    switchFormula() {
      if (this.formula === undefined || this.formula === '') {
        return;
      }

      this.action = true;
      let formulaUi = String(this.formula);
      if (!this.isCodeName) {
        formulaUi = String(this.formula);
        this.switchFormulaBefore = formulaUi;
        for (const item of this.dataForList) {
          formulaUi = formulaUi.replace(new RegExp(String(item.counterCode), 'g'), String(`[${item.counterCodeCnEn}]`));
        }
      } else {
        formulaUi = this.switchFormulaBefore;
      }

      if (this.formula !== formulaUi) {
        this.isCodeName = !this.isCodeName;
      }
      this.formula = formulaUi;
    },
    recordDoubleClick(event) {
      if (this.isCodeName) {
        return;
      }
      const { rowData } = event;
      this.formula = this.formula + rowData.counterCode;
    },
    getDataForAddCustomKpi() {
      const This = this;
      //This.pageSettingsForAddCustom.currentPage = This.$refs.pagerOfAddCustomKPI.ej2Instances.currentPage;
      this.$axios.post('/lte/pm/indicator/counterListData.html', {
        page: {
          pageNo: This.pageSettingsForAddCustom.currentPage,
          pageSize: This.pageSettingsForAddCustom.pageSize
        },
        countertypeid: this.nodeParam.countertypeid,
        netypeid: this.nodeParam.netypeid,
        neversionid: this.nodeParam.neversionid,
        systemId: '1',
        timecycle: 2
      }).then(response => {
        if (response.data.errorCode === 'SUCCESS') {
          const result = response.data.resultVal;
          //This.pageSettingsForAddCustom.totalRecordsCount = result.totalCount;
          //This.pageSettingsForAddCustom.currentPage = result.pageNo;
          This.dataForList = result.result;

          this.$emit('dataForList', this.dataForList);
          const locale = this._i18n.locale;
          for (let item of This.dataForList) {
            item.counterCodeCnEn = (locale === 'zh') ? item.counterCodeCn : item.counterCodeEn;
            item.counterUnitCnEn = (locale === 'zh') ? item.counterUnitCn : item.counterUnitEn;
          }
        } else {
          console.log('error', response.data);
        }
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
      return;
    },
    changeFormula(event) {
      this.formula = event.value;
      if (event.value !== '' && !this.action) {
        this.history.push(event.value);
      }
      this.action = false;
      this.$emit('formula', event.value);
    }
  },
  mounted() {
  },
  provide: {
    grid: [Reorder, Resize, ExcelExport, ContextMenu, Toolbar, Page]
  },
  computed: {
    searchData() {
      const This = this;
      const search = This.searchString.trim().toLowerCase();
      let searchData = This.dataForList;
      if (!search) {
        return searchData;
      }

      searchData = searchData.filter(item => {
        return (item.counterCodeCnEn.trim().toLowerCase().indexOf(search) !== -1);
      });

      return searchData;
    },
  },
  watch: {
    counterFormulaUi(val) {
      // console.log('watch counterFormulaUi',val)
      this.formula = val;
      return;
    },
    isNextStep(val) {
      //console.log('isNextStep',val)
      this.getDataForAddCustomKpi();
    },
  }
};

</script>
